import {Component, Input} from "@angular/core";
import {FormGroup} from "@angular/forms";
import {OrderActionData, OrderActionType} from "../../order-action-display.data";
import {MetaTagType} from "../../../../catalogue/meta-tag/meta-tag.data";

@Component({
    selector: "wbo-order-action-edit-form",
    styleUrls: ["./order-action-edit-form.component.scss"],
    templateUrl: "./order-action-edit-form.component.html"
})
export class OrderActionEditFormComponent {
    OrderActionType = OrderActionType;
    MetaTagType = MetaTagType;

    @Input() orderAction: OrderActionData;
    @Input() formGroup: FormGroup;

    get notificationMessage(): string {
        return this.orderAction.description && this.orderAction.location ? "wbo.order-action-display.edit.message.orderReady.orderDescriptionReadyFromLocation"
            : this.orderAction.description ? "wbo.order-action-display.edit.message.orderReady.orderDescriptionReady"
                : this.orderAction.location ? "wbo.order-action-display.edit.message.orderReady.orderReadyFromLocation"
                    : "wbo.order-action-display.edit.message.orderReady.orderReady";
    }
}
